import { setHeroScroll, setHeroScrollFrame } from "./home/setHeroScroll";

document.addEventListener("DOMContentLoaded", function () {
  setHeroScroll();
  setHeroScrollFrame();
});